var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.003125 5.89375C0.003125 2.6375 2.69063 0 6.00313 0C9.31563 0 12.0031 2.6375 12.0031 5.89375C12.0031 9.62188 8.24688 14.0906 6.67813 15.7937C6.30938 16.1938 5.69375 16.1938 5.325 15.7937C3.75625 14.0906 0 9.62188 0 5.89375H0.003125ZM6.00313 8C6.53356 8 7.04227 7.78929 7.41734 7.41421C7.79241 7.03914 8.00313 6.53043 8.00313 6C8.00313 5.46957 7.79241 4.96086 7.41734 4.58579C7.04227 4.21071 6.53356 4 6.00313 4C5.47269 4 4.96398 4.21071 4.58891 4.58579C4.21384 4.96086 4.00313 5.46957 4.00313 6C4.00313 6.53043 4.21384 7.03914 4.58891 7.41421C4.96398 7.78929 5.47269 8 6.00313 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location-white.da48dc2ba3c7f3b6ae7d5b2144fd3797.svg";
export { ForwardRef as ReactComponent };